var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrowDown_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrowDown_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.575c-.133 0-.258-.02-.375-.063a.878.878 0 0 1-.325-.212l-5.6-5.6a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7a.93.93 0 0 1 .713-.288.977.977 0 0 1 .687.288l3.9 3.875V3c0-.283.096-.52.287-.712A.968.968 0 0 1 12 2c.283 0 .52.096.713.288.191.191.287.429.287.712v15.175l3.875-3.875c.2-.2.438-.3.712-.3.276 0 .513.1.713.3.183.2.275.438.275.712a.932.932 0 0 1-.275.688l-5.6 5.6c-.1.1-.208.17-.325.212a1.105 1.105 0 0 1-.375.063Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowDown;